import { render, staticRenderFns } from "./TransferDetails.vue?vue&type=template&id=b1e2ec6a"
import script from "./TransferDetails.vue?vue&type=script&lang=js"
export * from "./TransferDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports